import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const RecognitionRoute = lazyWithRetries(() => import('.'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.admin.manageRecognition(),
    element: (
      <StandardPageLayout
        elementId="recognitionRoute"
        maxWidth={900}
        title={<T _str="Recognition" />}>
        <Suspense fallback={<RouteLoading />}>
          <RecognitionRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
